import { cities, states } from '../constants/cities';


/* -------------------- normalize & helpers -------------------- */
export function normalize(s) {
  return (s ?? '')
    .toString()
    .normalize('NFKD')               // split accents
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/gi, ' ')    // non-alnum -> space
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}
const matches = (a, b) => normalize(a) === normalize(b);
const anyMatch = (val, list = []) => list.some((x) => matches(val, x));
export function titleCase(s) {
  return (s || '').toLowerCase().replace(/\b\w/g, (m) => m.toUpperCase());
}

/* -------------------- state code map (full) -------------------- */
const STATE_CODE_TO_NAME = {
  AL:'Alabama', AK:'Alaska', AZ:'Arizona', AR:'Arkansas', CA:'California',
  CO:'Colorado', CT:'Connecticut', DE:'Delaware', FL:'Florida', GA:'Georgia',
  HI:'Hawaii', ID:'Idaho', IL:'Illinois', IN:'Indiana', IA:'Iowa',
  KS:'Kansas', KY:'Kentucky', LA:'Louisiana', ME:'Maine', MD:'Maryland',
  MA:'Massachusetts', MI:'Michigan', MN:'Minnesota', MS:'Mississippi', MO:'Missouri',
  MT:'Montana', NE:'Nebraska', NV:'Nevada', NH:'New Hampshire', NJ:'New Jersey',
  NM:'New Mexico', NY:'New York', NC:'North Carolina', ND:'North Dakota',
  OH:'Ohio', OK:'Oklahoma', OR:'Oregon', PA:'Pennsylvania', RI:'Rhode Island',
  SC:'South Carolina', SD:'South Dakota', TN:'Tennessee', TX:'Texas', UT:'Utah',
  VT:'Vermont', VA:'Virginia', WA:'Washington', WV:'West Virginia', WI:'Wisconsin', WY:'Wyoming',
  DC:'District of Columbia', PR:'Puerto Rico', GU:'Guam', VI:'U.S. Virgin Islands',
  AS:'American Samoa', MP:'Northern Mariana Islands'
};

const qstr = (v) => String(v ?? '').toLowerCase();

// Fallback slug builder if one isn't provided in the constants
const slugify = (s) =>
  String(s ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

// returns the city object or null
export function findCity(labelOrName = '') {
  const q = qstr(labelOrName);

  console.log(cities, labelOrName)

  const city =
    cities.find((c) => qstr(c.name) === q) ||
    cities.find((c) => qstr(c.slug ?? slugify(c.name)) === q);

  return city ?? null;
}

// returns { name: countyName, state } or null
export function findCounty(labelOrName = '') {
  const q = qstr(labelOrName);

  // county lives on city entries; match either the county's name or a city whose slug/name matches q
  const byCounty = cities.find((c) => qstr(c.county) === q);
  if (byCounty) return { name: byCounty.county, state: byCounty.state };

  // if the user passed a city, infer its county
  const city =
    cities.find((c) => qstr(c.name) === q) ||
    cities.find((c) => qstr(c.slug ?? slugify(c.name)) === q);

  return city ? { name: city.county, state: city.state } : null;
}

// returns { name: stateName } or null
export function findState(labelOrName = '') {
  const q = qstr(labelOrName);
  const name = states.find((s) => qstr(s) === q);
  return name ? { name } : null;
}